import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "login-container" }, null, -1)
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "t" }, null, -1)
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "form-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "CDSS辅助诊断系统数据大屏", -1)
const _hoisted_7 = { class: "input" }
const _hoisted_8 = { class: "input" }
const _hoisted_9 = { class: "remember" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("记住用户名和密码")
const _hoisted_11 = { class: "submit" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "b" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "username",
              id: "username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event)),
              placeholder: "请输入用户名"
            }, null, 512), [
              [_vModelText, _ctx.userName]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              name: "password",
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              placeholder: "请输入密码"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.remember) = $event)),
              id: ""
            }, null, 512), [
              [_vModelCheckbox, _ctx.remember]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "submit",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.login()))
            }, "登录")
          ])
        ])
      ]),
      _hoisted_12
    ])
  ], 64))
}